export default __webpack_public_path__ + "static/media/img12.df229573.jpg";